import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Shop', to: '/products' },
    { label: 'Collections', to: '/clothing' },
    { label: 'Our Story', to: '/about' },
    { label: 'Contact', to: '/contact' },
  ];

  const transparent = isHome && !scrolled;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${transparent ? 'bg-transparent' : 'bg-white shadow-md'}`}>
      <div className="w-full px-6 md:px-12 lg:px-20 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/9f89bdf23d5aff8ba988416fefdf93f3/38d513abdc1c9c2789b148500dd3e524.png"
              alt="SheWearHouse Logo"
              className="h-14 w-auto transition-all duration-300"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map(link => (
              <Link
                key={link.label}
                to={link.to}
                className={`font-medium transition-colors cursor-pointer ${transparent ? 'text-amber-100 hover:text-amber-300' : 'text-gray-700 hover:text-amber-600'}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Actions */}
          <div className="flex items-center space-x-4">
            {['ri-search-line', 'ri-heart-line', 'ri-shopping-bag-line'].map(icon => (
              <button
                key={icon}
                className={`w-10 h-10 flex items-center justify-center transition-colors cursor-pointer ${transparent ? 'text-amber-100 hover:text-amber-300' : 'text-gray-700 hover:text-amber-600'}`}
              >
                <i className={`${icon} text-xl`}></i>
              </button>
            ))}
            <Link
              to="/contact"
              className={`hidden md:inline-flex px-6 py-2 rounded-full border-2 font-medium transition-all whitespace-nowrap cursor-pointer ${transparent ? 'border-amber-300 text-amber-100 hover:bg-amber-500/20' : 'border-amber-600 text-amber-600 hover:bg-amber-600 hover:text-white'}`}
            >
              Contact Us
            </Link>
            <button
              className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${transparent ? 'text-amber-100' : 'text-gray-700'}`}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-amber-200/30">
            <nav className="flex flex-col space-y-4 pt-4">
              {navLinks.map(link => (
                <Link
                  key={link.label}
                  to={link.to}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-gray-700 hover:text-amber-600 transition-colors font-medium"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
